// extracted by mini-css-extract-plugin
export default {"imageWrapper":"TH-z","hovered":"UH-z","hoverImage":"VH-z","mainImage":"WH-z","imageNoBackground":"XH-z","fullSizeImage":"YH-z"};